@if (title()) {
<h3 [ngClass]="titleCssClass() || 'dottnet-content-title'">{{ title() }}</h3>
}
<ng-template #contentListHtml>@if (contentInternal(); as contentList) {
    <div [hidden]="!contentRendered" class="flex-row flex-wrap flex-justify-start content-list-wrapper">
        @if ( ![ ContentVisualizationType.GridCard, ContentVisualizationType.ListVideoCard, ContentVisualizationType.StandardCard ].includes(visualizationType()) ) { @for (content of contentList; track trackByFn($index, content); let last = $last) {
        <dottnet-generic-card [content]="content" class="generic-card-element" [visualizationType]="visualizationType()" [buttonAction]="
				templateFromRoute === 'ricerca' ? buttonAction() + ' ' + content.template : buttonAction()
			" [ngStyle]="{ 'max-width': cardFlexBasis() + '%' }">
            @if (last && !contentRendered) { {{ onContentRendered(true) }} } @if (content.idMinisito > 0) {
            <span class="content-container-info" detail_container>
        {{ content.tipoContenuto }} {{ 'dottnet.search.containerinfo' | translate }}
        {{ content.tipoContesto }}
        <a routerLink="/{{ content.tipoContesto }}/{{ content.idMinisito }}" class="container-link">{{
          content.titoloContesto }}</a>
      </span> } @if (content.idMinisito > 0) {
            <span class="content-container-info" detail_container_mobile>
        {{ content.tipoContenuto }} {{ 'dottnet.search.containerinfo' | translate }}
        {{ content.tipoContesto }}
        <a routerLink="/{{ content.tipoContesto }}/{{ content.idMinisito }}" class="container-link">{{
          content.titoloContesto }}</a>
      </span> } @if (content.wordList) {
            <span class="content-stem" detail>
        <span class="search-wordlist"> {{ 'dottnet.search.wordlist' | translate }} </span> {{ content.wordList }}
            </span>
            }
        </dottnet-generic-card>
        } } @if (visualizationType() === ContentVisualizationType.GridCard) {
        <div class="flex-row flex-wrap">
            @for (content of contentList; track trackByFn($index, content); let last = $last) {
            <dottnet-grid-card class="grid-card-element" [content]="content">
                @if (last && !contentRendered) { {{ onContentRendered(true) }} }
            </dottnet-grid-card>
            }
        </div>
        } @if (visualizationType() === ContentVisualizationType.StandardCard) { @for (content of contentList; track trackByFn($index, content); let last = $last) {
        <dottnet-standard-card class="standard-card-element" [content]="content" [isHomeCard]="isHomePage()">
            @if (last && !contentRendered) { {{ onContentRendered(true) }} }
        </dottnet-standard-card>
        } } @if (visualizationType() === ContentVisualizationType.ListVideoCard) { @for (content of contentList; track trackByFn($index, content); let last = $last) {
        <dottnet-video-list-card [ngStyle]="{ 'max-width': cardFlexBasis() + '%' }" class="flex-col video-list-card-element" [content]="content" [buttonAction]="buttonAction()" [isPreview]="isVideo()">
            @if (last && !contentRendered) { {{ onContentRendered(true) }} }
        </dottnet-video-list-card>
        } } @if (more() && contentList.length >= howMany()) {
        <div class="more-button">
            <h4>
                <a id="moreLabel" (click)="moreContents()">{{ 'dottnet.shared.moreContent' | translate }}</a>
            </h4>
        </div>
        }
    </div>
    } @if (!contentRendered) {
    <dottnet-skeleton [contentRendered]="contentRendered" [skeletonElementsNumber]="skeletonElementsNumber" [visualizationType]="visualizationType()"></dottnet-skeleton>
    }
</ng-template>


@if(applyDeferring()){ @defer {
<ng-container *ngTemplateOutlet="contentListHtml"></ng-container>
} @placeholder {
<dottnet-skeleton [contentRendered]="false" [skeletonElementsNumber]="skeletonElementsNumber" [visualizationType]="visualizationType()"></dottnet-skeleton>
} }@else{
<ng-container *ngTemplateOutlet="contentListHtml"></ng-container>
}
